import { ReactNode } from 'react';
import Navbar from './Navbar';
import BottomNav from './BottomNav';
import MobileHeader from './MobileHeader';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen w-full max-w-full min-w-0 overflow-x-hidden bg-gray-50">
      <Navbar />
      <MobileHeader />
      <main className="w-full min-w-0 pb-24 pt-20 md:pb-0 md:pt-0">
        <div className="box-border w-full min-w-0 px-4 py-4 sm:px-6 md:py-6 lg:px-8">
          {children}
        </div>
      </main>
      <BottomNav />
    </div>
  );
}


